import React from 'react';
import { SettlementUploadType } from '../types/settlementUpload.types';

interface UploadSectionProps {
    uploadLoading: boolean;
    partnerFileInputRef: React.RefObject<HTMLInputElement | null>;
    riderFileInputRef: React.RefObject<HTMLInputElement | null>;
    onPartnerUploadClick: () => void;
    onRiderUploadClick: () => void;
    onFileChange: (event: React.ChangeEvent<HTMLInputElement>, uploadType: SettlementUploadType) => void;
}

const UploadSection: React.FC<UploadSectionProps> = ({
                                                         uploadLoading,
                                                         partnerFileInputRef,
                                                         riderFileInputRef,
                                                         onPartnerUploadClick,
                                                         onRiderUploadClick,
                                                         onFileChange,
                                                     }) => (
    <>
        {/* 업로드 버튼 영역 */}
        <div className="card upload-card">
            <div className="card-body">
                <div className="upload-button-group">
                    <div className="upload-button-wrapper">
                        <button
                            className="btn btn-primary upload-btn"
                            onClick={onRiderUploadClick}
                            disabled={uploadLoading}
                        >
                            <i className="fas fa-file-excel" />
                            라이더 주정산 업로드
                        </button>
                        <p className="upload-hint">라이더 주정산내역 엑셀 파일을 업로드합니다.</p>
                    </div>
                    <div className="upload-button-wrapper">
                        <button
                            className="btn btn-secondary upload-btn"
                            onClick={onPartnerUploadClick}
                            disabled={uploadLoading}
                        >
                            <i className="fas fa-file-excel" />
                            협력사 주정산 업로드
                        </button>
                        <p className="upload-hint">협력사 주정산내역 엑셀 파일을 업로드합니다.</p>
                    </div>
                </div>

                {/* 숨겨진 파일 입력 */}
                <input
                    ref={partnerFileInputRef}
                    type="file"
                    accept=".xlsx,.xls"
                    style={{ display: 'none' }}
                    onChange={(e) => onFileChange(e, 'PARTNER')}
                    disabled={uploadLoading}
                />
                <input
                    ref={riderFileInputRef}
                    type="file"
                    accept=".xlsx,.xls"
                    style={{ display: 'none' }}
                    onChange={(e) => onFileChange(e, 'RIDER')}
                    disabled={uploadLoading}
                />
            </div>
        </div>

        {/* 업로드 안내 */}
        <div className="upload-info-section info-item-highlight">
            <div className="info-item">
                <i className="fas fa-info-circle" />
                <span>업로드 순서: 라이더 주정산을 먼저 업로드한 후, 협력사 주정산을 업로드해주세요.</span>
            </div>
            <div className="info-item">
                <i className="fas fa-exclamation-circle" />
                <span>적용 순서: 같은 정산기간의 라이더 주정산을 먼저 적용해주세요. 협력사 주정산은 처음에 "적용 불가"로 표시되며, 라이더 주정산 적용 후 적용 버튼이 활성화됩니다.</span>
            </div>
            <div className="info-item">
                <i className="fas fa-exclamation-triangle" />
                <span>적용 후에는 취소할 수 없습니다. 신중하게 적용해주세요.</span>
            </div>
        </div>
    </>
);

export default UploadSection;
